import { authAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { forgotPasswordAPIUrls } from '../data';

type ResetPasswordParams = {
  token: string;
  password: string;
  confirmPassword: string;
};

type ResetPasswordResponse = {
  message: string;
};

export const resetPassword = withLogger(
  async (params: ResetPasswordParams): Promise<ResetPasswordResponse> => {
    const { data } = await authAxiosClient.post<ResetPasswordResponse>(
      forgotPasswordAPIUrls.reset,
      params,
    );

    return data;
  },
);
